import PropTypes from 'prop-types';
import React from 'react';


export default function SharingFavorites({ baseClassName, handleWhatsappClick, handleFacebookShareClick, handleCopyClick, isProcessing, handleSaveClick, isSaved, t, isCopied }) {
  return (
    <div className={ `sharing-favourites ${baseClassName}` }>
      <div className="sharing-favourites__container">
        <div className="sharing-favourites__container__sharing">
          { t("Share") }
          { handleFacebookShareClick ? (
            <span
              className="hundredicons-hr-icon-facebook"
              onClick={ handleFacebookShareClick }
            />
          ) : null }
          { handleWhatsappClick ? (
            <span
              className="hundredicons-whatsapp-icon-share"
              onClick={ handleWhatsappClick }
            />
          ) : null }
          { handleCopyClick ? (
            <span
              className={ `${isCopied ? 'hundredicons-check' : 'hundredicons-hr-copylinkl-share-icon'}` }
              onClick={ handleCopyClick }
            />
          ) : null }
        </div>
        <div
          className="sharing-favourites__container__favourites"
          onClick={ isProcessing ? undefined : handleSaveClick }
        >
          <span className={ `hundredicons-hr-icon-favorito${isSaved ? '-filled -is-saved' : ''} ` } />
          <span className="sharing-favourites__container__favourites__text">
            { isSaved && !isProcessing ? t("Saved!") : t("Save") }
          </span>
        </div>
      </div>
    </div>
  );
}

SharingFavorites.defaultProps = {
  baseClassName: '',
  handleWhatsappClick: () => {},
};

SharingFavorites.propTypes = {
  baseClassName: PropTypes.string,
  handleCopyClick: PropTypes.func.isRequired,
  handleFacebookShareClick: PropTypes.func.isRequired,
  handleSaveClick: PropTypes.func.isRequired,
  handleWhatsappClick: PropTypes.func,
  isCopied: PropTypes.bool.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  isSaved: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};
